import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionGuard } from 'src/guard/permission/permission.guard';
import { AuthenticationGuard } from 'src/guard/auth/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'chart',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./chart/chart.module').then(m => m.ChartModule),
    data: { slug: 'chart' },
  },
  {
    path: 'calibration',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./calibration/calibration.module').then(m => m.CalibrationModule),
    data: { slug: 'calibration' },
  },
  {
    path: 'maintenance',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./maintenance/maintenance.module').then(m => m.MaintenanceModule),
    data: { slug: 'maintenance' },
  },
  {
    path: 'settings',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
    data: { slug: 'settings' },
  },
  {
    path: 'about',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./about/about.module').then(m => m.AboutModule),
    data: { slug: 'about' },
  },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
